// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { linkListStyles } from "@vanmeter/Overrides/Widgets/Basic/LinkList";
import { fontConfig } from "@vanmeter/XDL/constants";
import { color } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

linkListStyles.titleWrapper = {
    css: css`
        display: flex;
    `,
};

linkListStyles.linkListWrapper = {};

linkListStyles.title = {
    variant: "h5",
    forwardAs: "span",
    css: css`
        &:empty {
            display: none;
        }
    `,
};

linkListStyles.titleLink = {
    typographyProps: {
        variant: "h5",
    },
    css: css`
        &:hover {
            & > ${TypographyStyle} {
                color: ${color("common.ui17")};
            }
        }
    `,
};

linkListStyles.listLink = {
    typographyProps: { ...fontConfig.xSmallSingleLine, weight: fontConfig.weight.regular },
    css: css`
        &:hover {
            & > ${TypographyStyle}, ${IconWrapper} {
                color: ${color("common.ui17")};
            }
        }
        ${IconWrapper} {
            margin: 0;
            &,
            & > svg {
                width: auto;
            }
        }
    `,
};
